module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MjguODk5IiBoZWlnaHQ9IjUyOC44OTkiPjxwYXRoIGZpbGw9IiM2NjYiIGQ9Ik0zMjguODgzIDg5LjEyNWwxMDcuNTkgMTA3LjU4OS0yNzIuMzQgMjcyLjM0TDU2LjYwNCAzNjEuNDY1bDI3Mi4yNzktMjcyLjM0em0xODkuMjMtMjUuOTQ4bC00Ny45ODEtNDcuOTgxYy0xOC41NDMtMTguNTQzLTQ4LjY1My0xOC41NDMtNjcuMjU5IDBsLTQ1Ljk2MSA0NS45NjEgMTA3LjU5IDEwNy41OSA1My42MTEtNTMuNjExYzE0LjM4Mi0xNC4zODMgMTQuMzgyLTM3LjU3NyAwLTUxLjk1OXpNLjMgNTEyLjY5Yy0xLjk1OCA4LjgxMiA1Ljk5OCAxNi43MDggMTQuODExIDE0LjU2NWwxMTkuODkxLTI5LjA2OUwyNy40NzMgMzkwLjU5Ny4zIDUxMi42OXoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/edit.svg
// module id = 3X5m
// module chunks = 1